import React from "react";
import useToggleModal from "../customHooks/useToggleModal";
import GDPR from "./GDPR";
import Kopvillkor from "./Kopvillkor";
import CustomModal from "./Modal2";

const BUTTON_LABEL_GDPR = "GDPR";
const BUTTON_LABEL_KOPVILLKOR = "Köpvillkor";
const MODAL_TITLE_GDPR = "GDPR på Empathy";
const MODAL_TITLE_KOPVILLKOR = "Köpvillkor";

export const Footer: React.FC = () => {
  const { isModalOpen, onCloseModal, onOpenModal } = useToggleModal();
  const {
    isModalOpen: isKopvillkorModalOpen,
    onCloseModal: onCloseKopvillkorModal,
    onOpenModal: onOpenKopvillkorModal,
  } = useToggleModal();

  return (
    <>
      <div className="flex items-center gap-10 justify-center mb-7 font-nunito mt-auto">
        <button onClick={onOpenModal} className="text-white">
          {BUTTON_LABEL_GDPR}
        </button>
        <button onClick={onOpenKopvillkorModal} className="text-white">
          {BUTTON_LABEL_KOPVILLKOR}
        </button>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        onClose={onCloseModal}
        title={MODAL_TITLE_GDPR}
      >
        <GDPR />
      </CustomModal>

      <CustomModal
        isOpen={isKopvillkorModalOpen}
        onClose={onCloseKopvillkorModal}
        title={MODAL_TITLE_KOPVILLKOR}
      >
        <Kopvillkor />
      </CustomModal>
    </>
  );
};
